export const data: object[] = [
  {
    id: "5dd2c342f3d66a78f372086f",
    index: 0,
    guid: "00aefb97-c50e-4e3c-bfae-46a7189da122",
    isActive: true,
    balance: "$1,201.82",
    picture: "http://placehold.it/32x32",
    age: 36,
    eyeColor: "blue",
    name: "George Garrett",
    gender: "male",
    company: "ACUSAGE",
    email: "georgegarrett@acusage.com",
    phone: "+1 (870) 582-2750",
    address: "517 Hewes Street, Flintville, North Dakota, 6392",
    about:
      "Esse in deserunt do tempor sit deserunt nisi aute elit enim nostrud dolor. Quis do exercitation eiusmod aute aute. Elit qui id excepteur culpa nostrud aute ipsum in sunt. Aliquip elit duis non ea duis dolor id ex. Officia ipsum culpa pariatur ut tempor aute officia nostrud veniam ipsum et. Excepteur dolore magna ad adipisicing elit do et tempor aliquip.\r\n",
    registered: "2018-03-17T12:37:58 -01:00",
    greeting: "Hello, George Garrett! You have 9 unread messages.",
    favoriteFruit: "banana",
    hours: 58.38,
    client: "activecollab",
  },
  {
    id: "5dd2c342fe4b5b65f73bfa04",
    index: 1,
    guid: "b9d510be-d5c8-45ef-8330-3efa8bfa57d6",
    isActive: true,
    balance: "$2,810.13",
    picture: "http://placehold.it/32x32",
    age: 38,
    eyeColor: "green",
    name: "Iris Short",
    gender: "female",
    company: "TETAK",
    email: "irisshort@tetak.com",
    phone: "+1 (903) 470-2456",
    address: "393 McDonald Avenue, Belva, New Jersey, 7825",
    about:
      "Quis ea culpa laboris non duis est nisi adipisicing dolore. Cupidatat id ipsum exercitation tempor enim irure amet irure ad et. Nostrud est proident amet reprehenderit est nulla ex qui.\r\n",
    registered: "2014-10-09T04:17:19 -02:00",
    greeting: "Hello, Iris Short! You have 2 unread messages.",
    favoriteFruit: "strawberry",
    hours: 102.45,
    client: "Microsoft",
  },
  {
    id: "5dd2c342720bc6d948e08781",
    index: 2,
    guid: "e4b16a81-bf63-4c4c-8e25-4de6880d9b39",
    isActive: true,
    balance: "$2,604.24",
    picture: "http://placehold.it/32x32",
    age: 38,
    eyeColor: "brown",
    name: "Hickman Flores",
    gender: "male",
    company: "APPLIDEC",
    email: "hickmanflores@applidec.com",
    phone: "+1 (952) 438-3670",
    address: "546 Sands Street, Tilden, Tennessee, 5149",
    about:
      "Ad anim proident et velit nostrud est mollit adipisicing fugiat labore ad incididunt veniam. Amet irure dolor deserunt irure nulla ipsum ex nisi et tempor. Proident officia in exercitation sit. Id fugiat irure aliquip qui sint commodo.\r\n",
    registered: "2017-05-28T08:44:20 -02:00",
    greeting: "Hello, Hickman Flores! You have 10 unread messages.",
    favoriteFruit: "apple",
    hours: 56.43,
    client: "Apple",
  },
  {
    id: "5dd2c3420604a1ae10c4fe2e",
    index: 3,
    guid: "0e031bff-1b2e-4318-a469-ba6b3ab3701f",
    isActive: false,
    balance: "$1,321.55",
    picture: "http://placehold.it/32x32",
    age: 34,
    eyeColor: "green",
    name: "Annmarie Burgess",
    gender: "female",
    company: "MALATHION",
    email: "annmarieburgess@malathion.com",
    phone: "+1 (813) 539-3118",
    address: "687 Irving Place, Umapine, Guam, 4431",
    about:
      "Enim cupidatat eu ex Lorem veniam labore cillum nisi ut aliquip duis. Reprehenderit esse officia ad aliqua duis cillum ut exercitation nostrud consectetur labore quis. Consectetur ullamco nisi laboris reprehenderit pariatur laboris enim ullamco aute officia minim consectetur tempor labore. Pariatur adipisicing dolor tempor aliquip amet tempor nisi cupidatat nulla magna tempor ullamco. Amet est ullamco mollit aute et officia pariatur consectetur consequat do sunt ex reprehenderit.\r\n",
    registered: "2018-08-27T02:11:53 -02:00",
    greeting: "Hello, Annmarie Burgess! You have 1 unread messages.",
    favoriteFruit: "strawberry",
    hours: 75.12,
    client: "Microsoft",
  },
  {
    id: "5dd2c342b633ee29c6346e8b",
    index: 4,
    guid: "fc983602-6476-4826-98ce-9a2070118eea",
    isActive: false,
    balance: "$2,562.00",
    picture: "http://placehold.it/32x32",
    age: 29,
    eyeColor: "green",
    name: "Noemi Blair",
    gender: "female",
    company: "PERMADYNE",
    email: "noemiblair@permadyne.com",
    phone: "+1 (948) 486-3560",
    address: "319 Calyer Street, Orin, Iowa, 4918",
    about:
      "Reprehenderit cillum incididunt duis id anim officia. In exercitation est in magna ullamco laborum. Aliquip et veniam excepteur sunt. Et commodo adipisicing dolor mollit magna occaecat quis ad velit in cupidatat quis labore fugiat. Est nostrud consequat aliquip ad aliquip.\r\n",
    registered: "2018-05-07T12:51:39 -02:00",
    greeting: "Hello, Noemi Blair! You have 10 unread messages.",
    favoriteFruit: "strawberry",
    hours: 76.59,
    client: "Asus",
  },
  {
    id: "5dd2c342a1a07dc6d65df02a",
    index: 5,
    guid: "685e63d1-7819-4217-ad0f-5cad2a7b16a0",
    isActive: true,
    balance: "$3,227.51",
    picture: "http://placehold.it/32x32",
    age: 33,
    eyeColor: "green",
    name: "Calderon Gilbert",
    gender: "male",
    company: "STUCCO",
    email: "calderongilbert@stucco.com",
    phone: "+1 (998) 538-2567",
    address: "209 Dinsmore Place, Klondike, Montana, 9018",
    about:
      "Et deserunt qui adipisicing id id culpa voluptate fugiat nisi nisi excepteur ullamco exercitation voluptate. Commodo proident voluptate ad voluptate quis excepteur excepteur commodo. Eiusmod anim fugiat Lorem deserunt pariatur cillum anim nostrud amet anim qui elit cupidatat. Ad aliquip fugiat minim officia ex veniam consequat aliquip aliquip.\r\n",
    registered: "2015-07-08T08:15:44 -02:00",
    greeting: "Hello, Calderon Gilbert! You have 6 unread messages.",
    favoriteFruit: "strawberry",
    hours: 1.01,
    client: "Dell",
  },
];
